import { useCallback, useEffect } from "react";
import {FORMAT_DATE_BACK, formatDate, isEmpty, postSubmit, stringToDate} from "ui-seeker/utils";
import {useContextSelector} from "use-context-selector";
import { AppCalendarEventsContext } from "../../../Providers";
import {useToaster} from "ui-seeker/core";


export default function useAppCalendarEventCreation() {
    const isOpen = useContextSelector(AppCalendarEventsContext, ({ state }) => state.isOpenFormModal)
    const eventToEdit = useContextSelector(AppCalendarEventsContext, ({ state }) => state.eventToEdit)
    const updateCalendarEvents = useContextSelector(AppCalendarEventsContext, ({ updateState }) => updateState)
    const events = useContextSelector(AppCalendarEventsContext, ({ state }) => state.eventsData)
    const formData = useContextSelector(AppCalendarEventsContext, ({ state }) => state.formData)
    const { showToaster } = useToaster()

    const updateForm = useCallback(newFormData => {
        updateCalendarEvents({ formData: { ...formData, ...newFormData } })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(formData),updateCalendarEvents ])

    const resetForm = useCallback(() => {
        updateCalendarEvents({ formData: {idEvent: null, dateRange: [], relevance: '1', title: null, description: null, dateType: '1Day', datePicker: null} })
    }, [updateCalendarEvents])

    const buildForm = useCallback(({start_date, end_date, name, description, id_event, level }) => {
        const isSingleDate = start_date === end_date;
        updateCalendarEvents({ formData: {
            idEvent: id_event,
            title: name,
            description,
            relevance: level,
            dateType: isSingleDate ? '1Day' : 'moreThanOneDay',
            ...isSingleDate
                ? { datePicker: stringToDate(start_date), dateRange: [] }
                : { dateRange: [
                        stringToDate(start_date),
                        stringToDate(end_date)
                    ], datePicker: null }
            }})
    }, [updateCalendarEvents])

    const buildData = useCallback(formData => {
        const date =
            formData.dateType !== "1Day"
                ? formData.dateRange
                    ? [
                        formatDate(formData.dateRange[0], { format: FORMAT_DATE_BACK }),
                        formatDate(formData.dateRange[1], { format: FORMAT_DATE_BACK })
                    ]
                    : []
                : [formatDate(formData.datePicker, { format: FORMAT_DATE_BACK })];

        return {
            id_event: formData.idEvent,
            name: formData.title,
            description: formData.description,
            date,
            level: formData.relevance,
        };
    }, []);

    const handleSubmit = useCallback(() => {
        const formattedFormData = buildData(formData);

        postSubmit('/api/event/create', formattedFormData)
            .then(res => {
                updateCalendarEvents({ eventsData: [...events, res], isOpenFormModal: false })
                showToaster.success("Event added successfully")
            })
            .catch(() => {
                showToaster.error("Error adding event")
            });
    }, [buildData, events, formData, showToaster, updateCalendarEvents]);


    useEffect(() => {
        if (!isOpen) {
            resetForm()
        }else if(!isEmpty(eventToEdit)){
            buildForm(eventToEdit)
        }
    }, [buildForm, eventToEdit, isOpen, resetForm])


    return {
        updateForm,
        isOpen,
        handleSubmit,
        updateCalendarEvents
    }
}